module.exports = __webpack_public_path__ + "static/media/armandthiery2.5630931b.jpg";